export const fr_FR = {
    "PREFIX": {
        "QUESTION": "Question",
        "QUESTION-PART": "Question",
        "PRE-RELEASE": "Document de préparation",
        "JOURNAL": "Journal"
    },
     "CONTENT": {
        "MARK": "point{{totalMarks > 1 && 's' || ''}}"
    }
};